/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Ota_DisabledInputs */

const en_mobile_ota_disabled = /** @type {(inputs: Mobile_Ota_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`OTA updates are disabled in this build.`)
};

const es_mobile_ota_disabled = /** @type {(inputs: Mobile_Ota_DisabledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las actualizaciones OTA están deshabilitadas en esta build.`)
};

/**
* | output |
* | --- |
* | "OTA updates are disabled in this build." |
*
* @param {Mobile_Ota_DisabledInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_ota_disabled = /** @type {((inputs?: Mobile_Ota_DisabledInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Ota_DisabledInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_ota_disabled(inputs)
	return en_mobile_ota_disabled(inputs)
});